import { Modal } from "./Modal.js";
import { DOMHelper } from "../Helpers/DOMHelper.js";

export class TradeInDisclaimer {
    constructor(app) {
        this.app = app;
        this.parentId = app.config.elementId;
        this.classAtt = "tradein-modal";
    }

    init() {
        this.tradeInModal = new Modal(this.app, "tradein-modal", this.getHtml(), null, "tradein-modal-class");
        this.tradeInModal.init();
        this.eventHandlers();
    }

    eventHandlers() {
        let $this = this;
        DOMHelper.addHandler(this.getSelector(".trade-in-value-confirm-btn"), "click", function () {
            $this.tradeInModal.hide();
        });
    }

    updateValues(tradeInValue, condition, mileage, vehicleName) {
        DOMHelper.setInnerHTML(this.getSelector("#estimate-value"), tradeInValue);
        DOMHelper.setInnerHTML(this.getSelector(".vehicle-name"), vehicleName);
        DOMHelper.setInnerHTML(this.getSelector("#estimate-condition"), condition);
        DOMHelper.setInnerHTML(this.getSelector("#estimate-mileage"), mileage);
    }

    getHtml() {
        return `<div class="trade-in-modal">
    <div class="header">
        <p>After dealer inspection and market conditions, these values may be ajusted. The dealer will confirm the final evaluation.</p>
    </div>

    <div class="vehicle-information">
        <p class="estimate-text-1">Your estimated value for your trade in is <span id="estimate-value"></span></p>
        <p class="vehicle-name" style="text-transform: uppercase;"></p>
        <p class="mileage">Mileage: <span id="estimate-mileage"></span></p>
        <p class="condition">Condition: <span id="estimate-condition"></span></p>
    </div>

    <div class="content">
        <p class="estimate-text-2">This is an estimate, not an offer:</p>
        <p>
            Thank you for your interest in trading your vehicle with us. Please note that the value that you enter in the trade-in field is your own estimate and does not constitute an offer to purchase. The final value of your trade-in vehicle needs to be evaluated at the dealership by a qualified staff member. Actual value may vary based on the vehicle condition, reconditioning costs, current market and other factors.
        </p><br>
        <p>
            To facilitate getting the most accurate trade in value, please bring your Driver’s license, your bank information if you currently have a loan on your vehicle. The vehicle’s title. Your proof of insurance and reports of any accidents you may have had in this vehicle. Other helpful items are a log of all your routine maintenance and any significant repairs if you have them.  If you had a loan, but have paid it off, you’ll need the original lien release.
        </p><br>
        <p>
            As an option, you can also upload pictures of your vehicle and send us comments in advance using our form.
        </p><br>
        <p>
            Please set up an appointment today and bring your vehicle, so that we can give you your final trade-in value. We are looking forward to helping you.
        </p><br>
    </div>

    <div class="confirm-button">
        <button type="button" class="color-white bg-blue trade-in-value-confirm-btn">Confirm</button>
    </div>
</div>`;
    }

    getSelector(selector) {
        return this.app.getSelector("." + this.classAtt + " " + selector);
    }
}
